// extracted by mini-css-extract-plugin
export default {"sectionTitleH2":"SectionTitleH2_sectionTitleH2__4OBvK"};